import {
  IQuestionNode,
  ISimplifiedNode,
} from 'components/ingestion/IngestedTree'
import { LessonStructure } from 'ingestion/AIGenerated/types'
import { getQuestionDescription, getQuestionTeacherNotes } from './utility'
import { cleanListElement } from 'ingestion/AIGenerated/utilities/utility'
import { createShortAnswer } from 'ingestion/nodeCreationHelpers'
import { createMultiPartQuestion } from './createMultiPartQuestion'

export function getQuestionsPracticeProblems(
  configKey: string,
  config: any,
  lesson: LessonStructure,
  name?: string,
): ISimplifiedNode[] {
  const questionNodes: ISimplifiedNode[] = []

  const descriptionBase = getQuestionDescription(
    configKey,
    config,
    lesson,
    name,
  )
  const teacherNotesBase = getQuestionTeacherNotes(
    configKey,
    config,
    lesson,
    name,
  )

  const descriptionsP = descriptionBase.match(/(<p>\d+\.)/g)
  let prevIndex = 0
  const descriptions = descriptionsP
    ? descriptionsP
        .map((dP, index) => {
          const i = descriptionBase.indexOf(dP)
          if (index === descriptionsP.length - 1) {
            return descriptionBase.slice(i)
          }
          const description = descriptionBase.slice(prevIndex, i)
          prevIndex = i
          return description
        })
        .filter((d) => !!d)
    : [descriptionBase]

  const teacherNotesP = teacherNotesBase.match(/(<p>\d+\.)/g)
  prevIndex = 0
  const teacherNotes = teacherNotesP
    ? teacherNotesP
        .map((dP, index) => {
          const i = teacherNotesBase.indexOf(dP)
          if (index === teacherNotesP.length - 1) {
            return descriptionBase.slice(i)
          }
          const teacherNote = teacherNotesBase.slice(prevIndex, i)
          prevIndex = i
          return teacherNote
        })
        .filter((d) => !!d)
    : [teacherNotesBase]
  descriptions.forEach((description, index) => {
    const teacherNote = teacherNotes[index] || ''

    const multiParts = description.match(/<ol(.*?)<\/ol>/g)
    if (multiParts) {
      const descParts = description.match(/<li(.*?)<\/li>/g)
      const tNotesMatchesLi = teacherNote.matchAll(/<li(.*?)<\/li>/g)
      const tNotesPartsLi: string[] = []
      for (const t of tNotesMatchesLi) {
        tNotesPartsLi.push(t[1])
      }
      const tNotesMatchesP = teacherNote.matchAll(/[<p>|\s][a-z]\.(.*?)<\/p>/g)
      const tNotesPartsP = []
      for (const t of tNotesMatchesP) {
        tNotesPartsP.push(t[1])
      }
      const tNotesParts =
        tNotesPartsLi.length > tNotesPartsP.length
          ? tNotesPartsLi
          : tNotesPartsP
      const mainDescription = description.match(/<p(.*?)<ol/g)

      const questionNode = createMultiPartQuestion(
        mainDescription ? mainDescription[0] : '',
        `Question ${index + 1}`,
        descParts?.map((d, i) =>
          createShortAnswer({
            description: cleanListElement(d) || '',
            title: `${i}.`,
            teacherNote:
              tNotesParts && tNotesParts[i]
                ? cleanListElement(tNotesParts[i]?.trim())
                : teacherNote,
          }),
        ) as IQuestionNode[],
      )
      questionNodes.push(questionNode)
      return
    }
    const questionNode = createShortAnswer({
      description: description || '',
      title: `Question ${index + 1}`,
      teacherNote,
    })
    questionNodes.push(questionNode)
  })

  return questionNodes
}
